export default __webpack_public_path__ + "fonts/CiscoSansExtraLightOblique-webfont.eot";